import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { LibMatchRouting } from './lib-match.routing';
import { NgModule } from '@angular/core';
import {LibUtilsPipesModule} from '@utils/pipes/lib-utils-pipes.module';
import {MatTooltipModule} from '@angular/material/tooltip';
import {LibAdCampaignModule} from '@components/ad-campaign/lib-ad-campaign.module';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatchTickerComponent} from './pages/match-ticker/match-ticker.component';
import {MatchOverviewComponent} from './pages/match-overview/match-overview.component';
import {MatchTickerItemComponent} from './components/match-ticker-item/match-ticker-item.component';
import {LibDialogsModule} from '../dialogs/lib-dialogs.module';
import {LibBannersModule} from '../banners/lib-banners.module';
import { MatchReporterBannerComponent } from './components/match-reporter-banner/match-reporter-banner.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatchTopBannerComponent } from './components/match-top-banner/match-top-banner.component';
import { MatchWidgetComponent } from './pages/match/match-widget/match-widget.component';
import { MatchWebComponent } from './pages/match/match-web/match-web.component';
import { MatchContainerComponent } from './pages/match/match-container/match-container.component';
import {ButtonsModule} from '@lib-modules/buttons/buttons.module';
import { MatchVideoHeaderComponent } from '@lib-modules/match/components/match-video-header/match-video-header.component';
import {LibVideoPlayerModule} from '@components/video-player/lib-video-player.module';
import {LibImageModule} from '@components/image/lib-image.module';
import { MatchBettingGameComponent } from './components/match-betting-game/match-betting-game.component';

@NgModule({
  declarations: [
    MatchTickerComponent,
    MatchOverviewComponent,
    MatchTickerItemComponent,
    MatchReporterBannerComponent,
    MatchTopBannerComponent,
    MatchWidgetComponent,
    MatchWebComponent,
    MatchContainerComponent,
    MatchVideoHeaderComponent,
    MatchBettingGameComponent,
  ],
    imports: [
        CommonModule,
        LibMatchRouting,
        LibUtilsPipesModule,
        LibAdCampaignModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatProgressSpinnerModule,
        LibDialogsModule,
        LibBannersModule,
        ButtonsModule,
        LibVideoPlayerModule,
        LibImageModule,
    ],
  exports: [
    MatchWidgetComponent
  ]
})
export class LibMatchModule {}
